import React from 'react';

import RangeSlider from '../../Default/RangeSlider';
import RadioButton from '../../Default/RadioButton';
import { MovementBehaviour } from '../../../../Game/Level/Blok/State';

export default function Movement({ updateBlokStateSettings, movementBehaviour, speed }) {
    return (
        <div className="side-bar-page-content">
            <div className="side-bar-row">
                <RadioButton
                    name="movementBehaviour"
                    value={MovementBehaviour.none}
                    activeValue={movementBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            movementBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Geen
                </RadioButton>
            </div>
            <hr />
            <div className="side-bar-row side-bar-row-title">Langs een lijn</div>
            <div className="side-bar-row">
                <RadioButton
                    name="movementBehaviour"
                    value={MovementBehaviour.backAndForth}
                    activeValue={movementBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            movementBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Heen en weer
                </RadioButton>
                <RadioButton
                    name="movementBehaviour"
                    value={MovementBehaviour.to}
                    activeValue={movementBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            movementBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Maar 1 keer
                </RadioButton>
            </div>
            <hr />
            <div className="side-bar-row side-bar-row-title">Vrij bewegend</div>
            <div className="side-bar-row">
                <RadioButton
                    name="movementBehaviour"
                    value={MovementBehaviour.free}
                    activeValue={movementBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            movementBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Ik kan bewegen en vallen
                </RadioButton>
                <RadioButton
                    name="movementBehaviour"
                    value={MovementBehaviour.flee}
                    activeValue={movementBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            movementBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Ik vlucht voor de speler
                </RadioButton>
                <RadioButton
                    name="movementBehaviour"
                    value={MovementBehaviour.approach}
                    activeValue={movementBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            movementBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Ik zoek de speler
                </RadioButton>
            </div>
            <hr />
            <div className="side-bar-row side-bar-row-title">Tempo</div>
            <div className="side-bar-row">
                <RangeSlider
                    currentValue={speed}
                    min={0}
                    max={20}
                    step={0.1}
                    sliderStep={1}
                    disabled={movementBehaviour === MovementBehaviour.none}
                    onChange={v =>
                        updateBlokStateSettings({
                            speed: v
                        })
                    }
                    valueOnSide
                />
            </div>
        </div>
    );
}
